export const arrangeDataForSheet = (
  row: any,
  data: any[],
  gettext: (key: string) => string,
) => {
  return data.map((col) => {
    let value = row[col.field];
    if (row[col.field] === "summary") {
      value = gettext("Sum");
    }
    return col.type === "number" && !value ? 0 : value;
  });
};
